import {
    apiRequest,
    dokumenpelantikanUpdate
} from "../../../../../services/adapters/kepegawaian/dokumenPelantikanService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", dokumenpelantikanUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository